import { SYSTEM_ADMIN } from 'constants/Constants';

export const CARRIER_AGREEMENT_SURFACES = {
    V1: 'v1',
    V2: 'v2'
};

const asArray = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    return value == null ? [] : [value];
};

const accountTypeValue = (type) => {
    if (typeof type === 'string') {
        return type;
    }
    return type?.type || type?.name || type?.accountType || '';
};

export const hasCarrierAccountType = (accountTypes) =>
    asArray(accountTypes).some((type) => accountTypeValue(type).toUpperCase() === 'CARRIER');

export const isCarrierAgreementContext = (session = {}, selectedAccount = {}) => {
    const sessionCarrier =
        session?.isCarrier || hasCarrierAccountType(session?.accountType);
    const selectedAccountCarrier =
        hasCarrierAccountType(selectedAccount?.accountTypes) ||
        hasCarrierAccountType(selectedAccount?.accountType) ||
        hasCarrierAccountType(selectedAccount?.types);

    if (sessionCarrier) {
        return true;
    }
    if (session?.userRole !== SYSTEM_ADMIN || !selectedAccount?.id) {
        return false;
    }
    return selectedAccountCarrier;
};

export const getCarrierAgreementSurfaces = ({
    isCarrierContext,
    isTitanServiceEnabled,
    isCloudHubConnectorActive
}) => {
    if (!isCarrierContext) {
        return [];
    }
    if (!isTitanServiceEnabled) {
        return [CARRIER_AGREEMENT_SURFACES.V2];
    }
    return isCloudHubConnectorActive
        ? [CARRIER_AGREEMENT_SURFACES.V1, CARRIER_AGREEMENT_SURFACES.V2]
        : [CARRIER_AGREEMENT_SURFACES.V1];
};

export const isCarrierV2Route = (pathname = '') => pathname.startsWith('/connections/v2');

export const isLegacyCarrierV1ChildRoute = (pathname = '') =>
    /^\/connections\/(?!v2(?:\/|$)|provider(?:\/|$))[^/]+\/[^/]+\/agreements$/.test(pathname);

export const isLegacyCarrierV2Route = (pathname = '') =>
    pathname.startsWith('/connections/provider') || pathname.startsWith('/provider-summary/v2');

export const hasCarrierSurface = (surfaces, surface) => surfaces.includes(surface);
